import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ChosenSignature from 'components/atoms/chosen_signature';
import SubscriptionSummary from 'components/atoms/subscription_summary';
import Seta from 'assets/images/seta.svg';
import Payment from 'components/molecules/payment';
import { serviceDadosVenda, SimulateAll } from 'store/modules/simulate_all_store/actions';
import { SimulateAllState } from 'store/modules/simulate_all_store/types';
import { ApplicationState } from 'store';

interface PlanosProps {
  viewPage: string;
  dadosPlanCheckout: any;
}

const Planos: React.FC<PlanosProps> = ({ viewPage, dadosPlanCheckout }) => {
  const PAYMENT_METHOD_CARD = 10;
  const dispatch = useDispatch();
  const [paymentType, setPaymentType] = useState('cartao');
  const [parcelas, setParcelas] = useState<object | null>(null);
  const [parcelaValorFinal, setParcelaValorFinal] = useState<string>('');
  const [parcelaCheckout, setParcelaCheckout] = useState<boolean>(false);
  const [parcelaRequest, setParcelaRequest] = useState<number>(0);
  const [simulateRequest, setSimulateRequest] = useState<boolean>(false);

  const { request, simulate_all } = useSelector<ApplicationState, SimulateAllState>(
    (state) => state.session.simulate_all,
  );

  useEffect(() => {
    if (dadosPlanCheckout) {
      setPaymentType(
        dadosPlanCheckout?.selected_package[0]?.sale?.formas_pagamento_id === PAYMENT_METHOD_CARD
          ? 'cartao'
          : 'boleto',
      );
    }
    dispatch(
      SimulateAll({
        plano_id: simulate_all?.plano,
        pacote: simulate_all?.package_name,
        pacote_adicional: '',
        renewal: false,
      }),
    );
    dispatch(serviceDadosVenda(simulate_all?.plano));
  }, [dadosPlanCheckout, simulate_all?.plano]);

  useEffect(() => {
    setSimulateRequest(request.loading);
  }, [request.loading]);

  const typePayment = (tipoPagamento: string, updateAll = false) => {
    !updateAll && setPaymentType(tipoPagamento);
  };

  return (
    <div className="container p-4">
      {viewPage !== 'checkout' && (
        <Link className="btn btn-link" to="/planos">
          <img className="mr-2" src={Seta} alt="seta" /> Voltar para os planos{' '}
        </Link>
      )}
      <div className="row mt-4">
        <div className="col-12 col-md-8">
          <h2 className="font-weight-bolder mb-3">Assinatura escolhida</h2>
          <ChosenSignature dadosPlanCheckout={dadosPlanCheckout} />
        </div>
        <div className="col-12 col-md-4">
          <SubscriptionSummary
            paymentType={paymentType}
            dadosPlanCheckout={dadosPlanCheckout}
            setParcelas={setParcelas}
            setParcelaValorFinal={setParcelaValorFinal}
            setParcelaCheckout={setParcelaCheckout}
            setParcelaRequest={setParcelaRequest}
          />
        </div>
        <div className="col-md-8 mt-5">
          <h2 className="font-weight-bolder mb-3">Pagamentos</h2>
          <Payment
            typePayment={typePayment}
            paymentType={paymentType}
            dadosPlanCheckout={dadosPlanCheckout}
            parcelas={parcelas}
            parcelaValorFinal={parcelaValorFinal}
            parcelaCheckout={parcelaCheckout}
            parcelaRequest={parcelaRequest}
            simulateRequest={simulateRequest}
          />
        </div>
      </div>
    </div>
  );
};

export default Planos;
